import {
  policyConfig,
  PolicyStatementType,
  PolicyType,
} from "shared";

import { fieldIsValid } from "../../../../../lib/helper";
import { CurrencyInput } from "../../../../../../common/Atoms/CurrencyInput";

import { IFieldProps } from "./fieldProps";

const config = policyConfig.maximum_threshold;

export function MaximumDue({
  policyFormData,
  invalids,
  handleChange,
}: IFieldProps) {
  let description = `Apply this policy when less than this amount is overdue on the invoice`;

  if (policyFormData.policy_type === PolicyType.STATEMENT) {
    description = `Do not send a statement if the balance is more than this amount. (In Statement Currency)`;
  }

  if (policyFormData.policy_type === PolicyType.CONTACT_ESCALATION) {
    description = `Apply this policy when the contact has less than this amount overdue on their account.`;
  }

  function getLabel() {
    if (policyFormData.policy_type === PolicyType.STATEMENT) {
      if (policyFormData.statement_type === PolicyStatementType.OUTSTANDING) {
        return `Maximum Outstanding Amount`;
      }

      if (policyFormData.statement_type === PolicyStatementType.OVERDUE) {
        return `Maximum Overdue Amount`;
      }
    }

    if (policyFormData.policy_type === PolicyType.CONTACT_ESCALATION ) {
      return `Maximum Overdue Amount`;
    }

    return config.label;
  }

  return (
    <CurrencyInput
      label={ getLabel() }
      helpIcon={ description }
      value={ policyFormData.maximum_threshold }
      onChange={ handleChange }
      name={ `maximum_threshold` }
      invalid={ fieldIsValid(`maximum_threshold`, invalids) }
    />
  );
}
